import { formatCurrency, formatNumber } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { Currency } from '@app/core/enums/currency.enum';
import { FormatType } from '@app/core/model/other/field-config';
import CustomDuration from '@app/shared/extra/custom-duration';
import { getCurrencySymbol, getLocale } from '@app/shared/extra/utils';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

@Pipe({
  name: 'fieldFormatType',
  standalone: false
})
export class FieldFormatTypePipe implements PipeTransform {
  public transform(input: any, formatType?: FormatType, currency?: Currency): any {
    const locale = getLocale();
    if (input !== void 0 && input !== '') {
      switch (formatType) {
        case 'integer':
          return formatNumber(input, locale, '1.0-0');
        case 'percent':
          return formatNumber(input * 100, locale, '1.1-1');
        case 'numeric':
          return formatNumber(input, locale, '1.0-1');
        case 'precise_number':
          return new Intl.NumberFormat(locale, {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2})
            .format(input);
        case 'duration':
          dayjs.extend(duration);
          return CustomDuration.humanize(dayjs.duration(input, 'd').locale(locale));
        case 'scientific':
          return new Intl.NumberFormat(locale, {style: 'decimal', notation: 'scientific', maximumFractionDigits: 1})
            .format(input);
        case 'engineering':
          return new Intl.NumberFormat(locale, {style: 'decimal', notation: 'compact', maximumFractionDigits: 2})
            .format(input);
        case 'currency':
          return formatCurrency(input, locale, getCurrencySymbol(currency), currency, '1.0-0');
        case 'decimal_currency':
          return formatCurrency(input, locale, getCurrencySymbol(currency), currency, '1.0-1');
        case 'precise_currency':
          return formatCurrency(input, locale, getCurrencySymbol(currency), currency, '1.0-6');
        case 'engineering_currency':
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
            notation: 'compact',
            maximumFractionDigits: 1
          }).format(input);
        default:
          return input;
      }
    } else {
      return '';
    }
  }
}
